module.exports = __webpack_public_path__ + "img/coupon-mockup-2.6bd169c4.png";